export default "__VITE_ASSET__BT0LurOk__"